module.exports = {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite.svg#phone",
      toString: function () {
        return this.url;
      }
    }